import { Button, Modal } from 'react-bootstrap'
import styled from 'styled-components'
import { ReactComponent as Close } from '../../assets/icons/x.svg'

export const WarnModalStyles = styled(Modal)`
  display: flex !important;
  align-items: center;
  background-color: "transparent";
  text-align: center;

  .modal {
    &-content {
      width: 485px;
      padding: 40px  34px 34px ;
      .logo-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        svg {
          margin-bottom: 10px;
        }
      }
      .title {
        text-align: center;
        font-weight: normal;
        font-size: 14px;
        &:last-of-type {
          margin-bottom: 12px;
        }
        &.main {
          font-weight: bold;
        }
      }

      .recover-pw {
        color: #4f4f4f;
        font-size: 13px;
      }

      select {
        height: 58px;
        padding: 14px;
      }

      .btn {
        padding: 12px 20px;
        &-primary {
          background-color: #0064a9;
        }
      }

      .login-btn {
        width: 100%;
        border-radius: 20px;
      }
    }

    &-header {
      padding: 0px;
      border-bottom: 0px;
      justify-content: unset;
    }

    &-body {
      padding: 0;
    }

    &-footer {
      border-top: none;
      justify-content: space-between;
      padding: 0px;
    }

    &-input {
      border: 1px solid #d9d9d9;
      padding: 14px;
      border-radius: 4px;
      color: #4f4f4f;
      width: 100%;
      outline: none;
      height: 58px;
      &-wrapper {
        margin-top: 15px;
        margin-bottom: 15px;
        position: relative;
      }
      &-btn {
        position: absolute;
        right: 14px;
        top: 65%;
        transform: translateY(-50%);
        border: none;
        background-color: transparent;
      }
    }
  }
`
export const CloseIcon = styled(Close)`
  width: 16px;
  height: 16px;
`

export const CloseButton = styled(Button)`
  cursor: pointer;
  border-radius: 50%;
  background-color: #fff ;
  position: relative;
  left: 40px;

  &:hover {
    background-color:#eeeeee;

  }

`